import React from 'react';
import BaseCard from '../common/layout/BaseCard';
import { Community } from './types';
import Avatar from '../common/display/Avatar';

interface CommunityMembersProps {
  community: Community;
}

export const CommunityMembers: React.FC<CommunityMembersProps> = ({ community }) => {
  const members = (community.members || []).filter(m => m.role === 'member');
  const displayedMembers = members.slice(0, 6);
  const remainingMembers = members.length - displayedMembers.length;

  return (
    <BaseCard>
      <h2 className="text-xl font-bold text-gray-900 mb-4">Members</h2>
      <div className="flex items-center gap-4">
        <div className="flex -space-x-2">
          {displayedMembers.map((member) => (
            <Avatar
              key={member.user_id}
              firstName={member.first_name || ''}
              lastName={member.last_name || ''}
              profileImageUrl={member.profile_image_url || undefined}
              size="small"
              className="border-2 border-white w-10 h-10"
            />
          ))}
          {remainingMembers > 0 && (
            <div className="relative w-10 h-10 flex items-center justify-center bg-gray-900 text-white text-xs font-bold rounded-full border-2 border-white">
              +{remainingMembers}
            </div>
          )}
        </div>
        <div>
          <p className="text-sm font-medium text-gray-900">{members.length} members</p>
          <p className="text-xs text-gray-500">Community members</p>
        </div>
      </div>
    </BaseCard>
  );
};